const canvas = document.getElementById('audienceChart');

if (canvas) {  // якщо елемент існує
  const ctx = canvas.getContext('2d');

  const data = {
    labels: [
      'Interactive E-Magazine',
      'Websites',
      'E-Newsletter',
      'Web TV',
      'Social'
    ],
    datasets: [{
      label: 'Audience',
      data: [71025, 466415, 55674, 80974, 105139],
      backgroundColor: [
        '#4e79a7',
        '#f28e2b',
        '#e15759',
        '#76b7b2',
        '#66cff5'
      ],
      borderWidth: 1,
      hoverOffset: 10
    }]
  };

  function formatNumber(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ", ");
  }

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = formatNumber(context.raw);
            return `${context.label}: ${value}`;
          }
        }
      },
      legend: {
        position: 'top',
        labels: {
          boxWidth: 20,
          padding: 15,
          font: {
            family: 'Montserrat',
            size: 16,
            style: 'italic',
            weight: 'normal'
          },
          color: '#333',
          generateLabels: function (chart) {
            const data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map((label, i) => {
                const value = formatNumber(data.datasets[0].data[i]);
                return {
                  text: `${label} – ${value}`,
                  fillStyle: data.datasets[0].backgroundColor[i],
                  strokeStyle: data.datasets[0].backgroundColor[i],
                  lineWidth: 1,
                  hidden: false,
                  index: i
                };
              });
            }
            return [];
          }
        }
      },
      datalabels: {
        color: '#fff',
        font: {
          family: 'Montserrat',
          weight: '600',
          size: 16
        },
        formatter: function (value, context) {
          const dataset = context.dataset.data;
          const total = dataset.reduce((a, b) => a + b, 0);
          const percent = (value / total * 100).toFixed(1);
          return `${percent}%`;
        },
        display: function () {
          return window.innerWidth > 768;
        },
        anchor: 'center',
        align: 'center',
        clamp: true
      }
    },
    animation: {
      animateScale: true,
      animateRotate: true
    },
    layout: {
      padding: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      }
    }
  };

  const chart = new Chart(ctx, {
    type: 'doughnut',
    data: data,
    options: options,
    plugins: [ChartDataLabels]
  });

  window.addEventListener('resize', () => {
    chart.update();
  });
}
